// Import danych dealerów z pliku JSON
import dealersJson from './dealers.json';

// Wyciągnięcie danych dealerów z JSON
export const dealersData = dealersJson.data;

// Centrum Polski dla mapy
export const mapCenter = {
  lat: 52.224106,
  lng: 19.597266
}; 